import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  constructor() {}
  longitude!: number;
  latitude!: number;

  getUserLocation() {
    return new Observable((observer) => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            // console.log(position)
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
            observer.next({
              latitude: this.latitude,
              longitude: this.longitude,
            });
            observer.complete();
          },
          (err) => {
            console.log(err)
            observer.error(err);
          }
        );
      } else observer.error('UnSupported Browser');
    });
  }


  async getOrFetchLocation() {
    if( !this.longitude || !this.latitude )
      await firstValueFrom(this.getUserLocation());

    return {
      latitude: this.latitude,
      longitude: this.longitude,
    }

  }
}

@Injectable({
  providedIn: 'root',
})
export class GeolocationService {
  async grantedPermission(): Promise<boolean> {
    const result = await navigator.permissions.query({ name: 'geolocation' });
    return result.state === 'granted'; 
  }

  async canPrompt(): Promise<boolean> {
    const result = await navigator.permissions.query({ name: 'geolocation' });
    return result.state === 'prompt' ; 
  }
}